<template>
  <div>
    <!-- Language Selector -->
    <div class="language-selector">
      <button 
        @click="changeLanguage('ca')" 
        :class="{ 'active': $i18n.locale === 'ca' }"
        class="lang-button"
      >
        CA
      </button>
      <button 
        @click="changeLanguage('es')" 
        :class="{ 'active': $i18n.locale === 'es' }"
        class="lang-button"
      >
        ES
      </button>
    </div>

    <div class="columns is-multiline first-part">
      <div class="column is-12 container-img">
        <img class="image-header" src="../assets/logo_partner.png" />
      </div>
      <div class="column is-12">
        <h1 class="title has-text-white has-text-centered has-text-weight-bold">
          {{ $t('LANDING.TITLE') }}
        </h1>
      </div>
      <div class="column is-12">
        <div class="columns is-multiline">
          <div class="column is-6 text-left">
            <p class="has-text-white has-text-weight-medium is-size-3 intro-text" v-html="$t('LANDING.INTRO')"></p>

            <div class="links">
              <a
                class="has-text-white has-text-weight-bold"
                :href="$i18n.locale === 'ca' ? '/Termes i Condicions 48 PRB - CATALUNYA Curs 25-26.pdf' : '/Termes i Condicions 65 CJT - CATALUNYA Curs 25-26.pdf'"
                :download="$i18n.locale === 'ca' ? 'Termes i Condicions 48 PRB - CATALUNYA Curs 25-26.pdf' : 'Termes i Condicions 65 CJT - CATALUNYA Curs 25-26.pdf'"
                >{{ $t('LANDING.LEGAL_BASES') }}</a
              >
              <span class="has-text-white mx-3">|</span>
              <a
                class="has-text-white has-text-weight-bold"
                :href="$i18n.locale === 'ca' ? '/Autoritzacio 48 PRB - CATALUNYA Curs 25-26.pdf' : '/Autoritzacio 65 CJT - CATALUNYA Curs 25-26.pdf'"
                :download="$i18n.locale === 'ca' ? 'Autoritzacio 48 PRB - CATALUNYA Curs 25-26.pdf' : 'Autoritzacio 65 CJT - CATALUNYA Curs 25-26.pdf'"
                >{{ $t('LANDING.AUTHORIZATION') }}</a
              >
            </div>
          </div>
          <div class="column is-6 pl-5 pr-5">
            <div class="banner-inscripcion">
              <div class="banner-content">
                <div class="logo-container">
                  <img
                    class="logo-concurso"
                    :src="require(`../assets/header/${$i18n.locale}_logo_general.png`)"
                  />
                </div>
                <div class="text-container">
                  <p class="banner-title has-text-black has-text-weight-bold">
                    {{ $t('LANDING.BANNER_TITLE') }}
                  </p>
                  <p class="banner-subtitle has-text-black">
                    {{ $t('LANDING.BANNER_SUBTITLE') }}
                  </p>

                  <button
                    @click="goToRegister()"
                    class="button has-text-weight-bold hover-btn"
                  >
                    {{ $t('LANDING.REGISTER_BUTTON') }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="columns is-multiline second-part">
      <div class="column is-2">
        <img class="rios-tinta" src="../assets/landing/rios-tinta.webp" />
      </div>
      <div class="column is-10">
        <h2
          class="subtitle is-size-3 has-text-black has-text-centered has-text-weight-bold"
        >
          {{ $t('LANDING.SUBTITLE_1') }}
        </h2>

        <p class="mb-5 is-size-5 text-description" v-html="$t('LANDING.DESCRIPTION_1')">
        </p>

        <h2
          class="subtitle is-size-3 has-text-black has-text-centered has-text-weight-bold"
          style="padding-top: 30px;"
        >
          {{ $t('LANDING.SUBTITLE_2') }}
        </h2>

        <p class="is-size-5 text-description" v-html="$t('LANDING.DESCRIPTION_2')">
        </p>
      </div>
    </div>
    <div class="columns is-multiline third-part mb-4">
      <div class="column is-12">
        <p class="is-size-5">
          {{ $t('LANDING.PHASES') }}
        </p>
      </div>

      <div class="column is-12 pl-2 pr-2">
        <div class="fase">
          <p class="has-text-weight-bold is-size-5 mb-1">
            {{ $t('LANDING.PROVINCIAL_PHASE_TITLE') }}
          </p>

          <p class="is-size-5">
            {{ $t('LANDING.PROVINCIAL_PHASE_DESC') }}
          </p>
        </div>
      </div>

      <div class="column is-12 pl-2 pr-2">
        <div class="fase">
          <p class="has-text-weight-bold is-size-5 mb-1">
            {{ $t('LANDING.REGIONAL_PHASE_TITLE') }}
          </p>

          <p class="is-size-5">
            {{ $t('LANDING.REGIONAL_PHASE_DESC') }}
          </p>
        </div>
      </div>
    </div>
    <div class="columns is-multiline fourth-part">
      <div class="column is-12 premios">
        <h2
          class="subtitle is-size-3 has-text-black has-text-centered has-text-weight-bold"
        >
          {{ $t('LANDING.PRIZES') }}
        </h2>
        <div class="is-flex is-justify-content-center">
          <hr />
        </div>
        <div class="is-flex image-text-premios">
          <img src="../assets/landing/premio1.webp" />

          <p class="is-size-5 premios-text" v-html="$t('LANDING.PRIZE_1')">
          </p>
        </div>
        <div class="is-flex is-justify-content-center">
          <hr />
        </div>
        <div class="is-flex image-text-premios">
          <img src="../assets/landing/premio2.webp" />

          <p class="is-size-5 premios-text" v-html="$t('LANDING.PRIZE_2')">
          </p>
        </div>
        <div class="is-flex is-justify-content-center">
          <hr />
        </div>
        <div class="column is-12">
          <p class="is-size-5 premios-text">
            {{ $t('LANDING.GALA_DESCRIPTION') }}
          </p>
        </div>
         <div class="is-flex is-justify-content-center">
          <hr />
        </div>
      </div>
    </div>
    <div class="columns is-multiline fifth-part">
      <div class="column is-12">
        <h2
          class="subtitle is-size-3 has-text-white has-text-centered has-text-weight-bold"
        >
          {{ $t('LANDING.CONTACT') }}
        </h2>
        <img class="logo-contacto" src="../assets/landing/contacto.webp" />
      </div>
      <div class="column is-12 mt-2 mb-2">
        <br /><br /><br />
        <p class="is-size-5 has-text-white">
          {{ $t('LANDING.CONTACT_INFO') }}
        </p>
      </div>
    </div>
    <div class="columns is-multiline footer">
      <div
        class="column is-12 is-flex is-justify-content-space-between"
      >
        <img src="../assets/logo_partner.png" />
      </div>
      <div class="column is-12 ">
        <hr />
      </div>
      <div class="column is-12">
        <p class="is-size-6 has-text-white has-text-right">
          © 2026 The Coca-Cola Company. Todos los derechos reservados.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "landing",
  components: {},
  data() {
    return {};
  },
  methods: {
    changeLanguage(lang) {
      this.$i18n.locale = lang;
    },
    goToRegister() {
      this.$router.push({
        path: "/login",
        query: { lang: this.$i18n.locale }
      });
    },
    downloadPDF(pdfName) {
      const pdfUrl = require(`@/assets/landing/${pdfName}.pdf`);

      const link = document.createElement("a");
      link.href = pdfUrl;
      link.setAttribute("download", `${pdfName}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../styles/variables.scss";

// Language Selector Styles
.language-selector {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  gap: 10px;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 8px;
  border-radius: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.lang-button {
  background-color: transparent;
  color: #333;
  border: none;
  padding: 8px 16px;
  border-radius: 20px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;

  &:hover {
    background-color: rgba(244, 0, 8, 0.1);
  }

  &.active {
    background-color: #f40008;
    color: white;
  }
}

h1 {
  font-size: 64px;
  line-height: 1.2;
  margin-bottom: 40px !important;
}
.first-part {
  min-height: 100vh;
  background: 
    linear-gradient(to right, rgba(244, 0, 8, 0.95) 0%, rgba(244, 0, 8, 0.85) 30%, rgba(244, 0, 8, 0.6) 60%, rgba(244, 0, 8, 0.45) 85%, rgba(244, 0, 8, 0.35) 100%),
    url('../assets/img/jovenes_talentos.jpg');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  padding: 40px;
  padding-left: 60px;
  padding-right: 60px;
  padding-bottom: 20vh;
  padding-top: 30px;

  .container-img {
    height: fit-content;
    margin-bottom: 60px;

    .image-header {
      max-height: 50px;
    }
  }

  .intro-text {
    line-height: 1.5;
    font-size: 24px !important;
    margin-bottom: 50px;
  }

  .links {
    margin-top: 20px;
    display: flex;
    align-items: center;
    
    a {
      text-decoration: underline;
      font-size: 18px !important;
    }
    
    span {
      font-size: 18px;
    }
  }

  .text-left {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .banner-inscripcion {
    border-radius: 25px;
    background-color: white;
    padding: 30px;
    display: flex;
    align-items: center;
    justify-content: center;

    .banner-content {
      display: flex;
      align-items: center;
      gap: 40px;
      width: 100%;
    }

    .logo-container {
      flex: 0 0 auto;
      
      img {
        max-height: 200px;
        width: auto;
      }
    }

    .text-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .banner-title {
      font-size: 28px;
      line-height: 1.2;
      margin-bottom: 15px;
    }

    .banner-subtitle {
      font-size: 18px;
      line-height: 1.4;
      margin-bottom: 25px;
    }

    button {
      color: white;
      background-color: #f40008;
      border: none;
      border-radius: 50px;
      padding: 15px 40px;
      font-size: 16px;
      width: auto;
      text-transform: none;
    }
  }
}

.second-part {
  padding: 30px;
  padding-left: 60px;
  padding-right: 60px;
  background-color: white;
  padding-bottom: 0px;

  .rios-tinta {
    min-height: 300px;
  }

  .text-description {
    line-height: 1.3;
  }
}

.third-part {
  padding: 30px;
  padding-left: 60px;
  padding-right: 60px;
  background-color: white;

  .fase {
    padding: 16px;
    border-radius: 15px;
    background-color: #ededed;
  }
}

.fourth-part {
  padding: 50px;
  padding-left: 70px;
  padding-right: 70px;
  background-color: #f40008;

  .premios {
    background-color: white;
    border-radius: 25px;
    padding: 16px;
    padding-left: 30px;
    padding-right: 30px;

    img {
      max-height: 70px;
      margin-right: 25px;
    }

    hr {
      width: 300px;
      height: 1px;
      background-color: #f40008;
    }

    .image-text-premios {
      align-items: center;
    }
  }

  .premios-text {
    line-height: 1.4;
  }
}

.fifth-part {
  padding: 30px;
  padding-left: 60px;
  padding-right: 60px;
  background-color: black;

  .logo-contacto {
    right: 30px;
    margin-top: -130px;
    position: absolute;
    max-height: 200px;
  }

  @media (max-width: 767px) {
    .logo-contacto {
      right: 0px;
      margin-top: -120px;
      max-height: 100px;
    }
  }

  .line-spacing {
    line-height: 1.6;
  }

  a {
    text-decoration: underline;
  }
}

.sixth-part {
  padding: 30px;
  padding-left: 60px;
  padding-right: 60px;
  background-color: white;

  button {
    color: white;
    background-color: #f40008;
    border: none;
    border-radius: 10px;
    width: 100%;
    font-weight: bold;
    height: 50px;
  }
}

.footer {
  padding: 30px;
  padding-left: 60px;
  padding-right: 60px;
  background-color: black;

  img {
    max-height: 30px;
  }

  hr {
    width: 100%;
    height: 1px;
    background-color: white;
  }

  .location {
    padding: 8px;
    padding-left: 14px;
    padding-right: 14px;
    border: solid 1px white;
    border-radius: 25px;
  }

  .social-media {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    width: 28px;
    border: solid 1px white;
    border-radius: 50%;

    a {
      color: white;
    }
  }
}

.hover-btn:hover {
  background-color: #c90007 !important;
}

// Tablet (hasta 1024px)
@media (max-width: 1024px) {
  h1 {
    font-size: 48px !important;
    margin-bottom: 30px !important;
  }

  .first-part {
    padding: 30px !important;
    padding-bottom: 10vh !important;

    .intro-text {
      font-size: 20px !important;
      margin-bottom: 30px !important;
    }

    .banner-inscripcion {
      padding: 30px !important;

      .banner-content {
        flex-direction: column !important;
        gap: 30px !important;
      }

      .logo-container {
        text-align: center;
        
        img {
          max-height: 180px !important;
        }
      }

      .text-container {
        width: 100%;
      }

      .banner-title {
        font-size: 26px !important;
      }

      .banner-subtitle {
        font-size: 17px !important;
      }

      button {
        padding: 14px 35px !important;
        font-size: 15px !important;
      }
    }
  }

  .second-part,
  .third-part,
  .fourth-part,
  .fifth-part {
    padding: 20px !important;
    padding-left: 40px !important;
    padding-right: 40px !important;
  }
}

// Mobile (hasta 768px)
@media (max-width: 768px) {
  .language-selector {
    top: 10px;
    right: 10px;
    padding: 6px;
    gap: 6px;
  }

  .lang-button {
    padding: 6px 12px;
    font-size: 12px;
  }

  h1 {
    font-size: 36px !important;
    margin-bottom: 20px !important;
    line-height: 1.3 !important;
  }

  .first-part {
    padding: 20px !important;
    padding-bottom: 5vh !important;
    background: 
      linear-gradient(to bottom, rgba(244, 0, 8, 0.9) 0%, rgba(244, 0, 8, 0.85) 100%),
      url('../assets/img/jovenes_talentos.jpg') !important;

    .container-img {
      margin-bottom: 30px !important;
      padding: 0 !important;
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
    }

    .intro-text {
      font-size: 18px !important;
      margin-bottom: 25px !important;
    }

    .links {
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 10px;

      span {
        display: none;
      }

      a {
        font-size: 16px !important;
      }
    }

    .text-left {
      padding: 20px !important;
    }

    .column {
      padding: 10px;
    }

    .banner-inscripcion {
      padding: 20px !important;
      margin: 0 !important;

      .banner-content {
        flex-direction: column !important;
        gap: 20px !important;
      }

      .logo-container {
        text-align: center;
        
        img {
          max-height: 120px !important;
        }
      }

      .banner-title {
        font-size: 22px !important;
        margin-bottom: 10px !important;
      }

      .banner-subtitle {
        font-size: 15px !important;
        margin-bottom: 20px !important;
      }

      button {
        padding: 12px 30px !important;
        font-size: 14px !important;
      }
    }
  }

  .second-part,
  .third-part {
    padding: 20px !important;
    
    .rios-tinta {
      min-height: 150px !important;
      width: 100%;
      object-fit: contain;
    }
  }

  .fourth-part {
    padding: 20px !important;

    .premios {
      padding: 15px !important;

      .image-text-premios {
        flex-direction: column !important;
        text-align: center;

        img {
          margin-right: 0 !important;
          margin-bottom: 15px !important;
        }
      }

      hr {
        width: 150px !important;
      }
    }
  }

  .fifth-part {
    padding: 20px !important;
  }

  .footer {
    padding: 20px !important;

    img {
      max-height: 25px !important;
    }
  }
}

// Mobile pequeño (hasta 480px)
@media (max-width: 480px) {
  h1 {
    font-size: 28px !important;
  }

  .first-part {
    .intro-text {
      font-size: 16px !important;
    }

    .banner-inscripcion {
      .logo-container img {
        max-height: 100px !important;
      }

      .banner-title {
        font-size: 20px !important;
      }

      .banner-subtitle {
        font-size: 14px !important;
      }
    }
  }
}
</style>
